import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
// @mui

// ----------------------------------------------------------------------

function Plus({ color }: { color?: string }) {
  const theme = useTheme();

  const PRIMARY_MAIN = theme.palette.primary.main;
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
      <path
        d="M14.25 8.25H9.75V3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75V8.25H3.75C3.33579 8.25 3 8.58579 3 9C3 9.41421 3.33579 9.75 3.75 9.75H8.25V14.25C8.25 14.6642 8.58579 15 9 15C9.41421 15 9.75 14.6642 9.75 14.25V9.75H14.25C14.6642 9.75 15 9.41421 15 9C15 8.58579 14.6642 8.25 14.25 8.25Z"
        fill={color || PRIMARY_MAIN}
      />
    </svg>
  );
}

export default memo(Plus);
